import type { IconKey } from "../../data/vocab/topic-display";

// Stroke-based, currentColor SVGs — no emoji (brand.md §7). Each path set is
// drawn on a 24×24 viewBox so the tile can scale the glyph freely.
const PATHS: Record<IconKey, React.ReactNode> = {
  sparkles: (
    <path d="M12 3l1.8 4.7L18.5 9.5 13.8 11.3 12 16l-1.8-4.7L5.5 9.5l4.7-1.8zM18 15l.9 2.3 2.3.9-2.3.9L18 21l-.9-2.3-2.3-.9 2.3-.9z" />
  ),
  wand: <path d="M15 4l5 5M14 5l5 5M4 20l9-9M9 3.5l.5 1.5L11 5.5 9.5 6 9 7.5 8.5 6 7 5.5 8.5 5z" />,
  clock: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </>
  ),
  users: (
    <>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20a6 6 0 0112 0M16 6a3 3 0 010 6M21 20a6 6 0 00-5-5.9" />
    </>
  ),
  heart: <path d="M12 21s-7-4.5-7-10a4 4 0 017-2.5A4 4 0 0119 11c0 5.5-7 10-7 10z" />,
  utensils: <path d="M5 3v7a2 2 0 002 2v9M5 3v4M7 3v4M16 3c-1.5 1-2 3-2 5s.5 4 2 5v6" />,
  shirt: <path d="M8 3l4 2 4-2 4 3-3 3v11H7V9L4 6z" />,
  home: <path d="M3 11l9-8 9 8M5 9.5V20h14V9.5" />,
  cart: (
    <>
      <path d="M3 4h2l2.5 12h11L21 8H6" />
      <circle cx="9" cy="20" r="1.4" />
      <circle cx="18" cy="20" r="1.4" />
    </>
  ),
  briefcase: <path d="M4 7h16v13H4zM9 7V5a2 2 0 012-2h2a2 2 0 012 2v2" />,
  book: <path d="M4 5a2 2 0 012-2h13v16H6a2 2 0 00-2 2zM19 19H6" />,
  ball: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 3.5v17M3.5 12h17M6 6c2 1.5 5 1.5 6 6M18 6c-2 1.5-5 1.5-6 6" />
    </>
  ),
  bus: <path d="M4 6a2 2 0 012-2h12a2 2 0 012 2v9H4zM4 15v3M20 15v3M8 4v11M16 4v11M4 11h16" />,
  wallet: <path d="M4 7a2 2 0 012-2h12v3M4 7v11a2 2 0 002 2h13V7zM16 13h2" />,
  monitor: <path d="M3 5h18v11H3zM9 20h6M12 16v4" />,
  leaf: <path d="M5 19c0-9 7-14 14-14 0 9-5 14-14 14zM5 19c2-5 5-8 9-10" />,
  cloud: <path d="M7 16a4 4 0 010-8 5 5 0 019.6 1.5A3.5 3.5 0 0117 16z" />,
  scale: <path d="M12 4v16M7 20h10M6 7l-3 6h6zM18 7l-3 6h6zM6 7l6-2 6 2" />,
  question: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M9.5 9.5a2.5 2.5 0 014.5 1.5c0 1.5-2 1.8-2 3.2" />
      <path d="M12 17.5h.01" />
    </>
  ),
  history: <path d="M4 12a8 8 0 108-8 8 8 0 00-6 2.7M5 4v3h3M12 8v4l3 2" />,
  layout: <path d="M4 4h16v16H4zM4 9h16M9 9v11" />,
};

export function TopicIcon({
  icon,
  size = 22,
  strokeWidth = 2,
}: {
  icon: IconKey;
  size?: number;
  strokeWidth?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      {PATHS[icon]}
    </svg>
  );
}
